<div class="page-content-container h-100 mt-4">
  <div class="top-content">
    <div class="w-100">
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-md-center pb-3">
        <div class="sub-title ps-0 ps-lg-2 mb-4 mb-lg-0">Distributions manager</div>
      </div>
    </div>
  </div>

  <div class="main-content">
    <div class="scrollable-area">
      <div class="w-100">
        <div class="section-filters">
          <nav mat-tab-nav-bar [tabPanel]="tabPanel">
            @for (tab of filterTabs; track tab.label) {
              <a mat-tab-link (click)="applyFilter(tab)" [active]="activeTab === tab">
                <mat-icon>{{ tab.icon }}</mat-icon>
                <span class="tab-label">{{ tab.label }}</span>
              </a>
            }
          </nav>
        </div>
        <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
      </div>

      <div class="w-100">
        <div class="separating-line mb-3" appFullWidthScroll [scrollableElement]="scrollableElement"></div>
        <div class="d-flex justify-content-end">
          <button
            mat-raised-button
            color="primary"
            class="create-btn btn-lg"
            type="button"
            (click)="createDistribution()">
            <span>Create Distribution</span>
          </button>
        </div>

        <div #scrollableElement>
          <table mat-table [dataSource]="dataSource" class="app-table">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex flex-column">
                  <span>{{ element.name }}</span>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="altName">
              <th mat-header-cell *matHeaderCellDef>Alt Name</th>
              <td mat-cell *matCellDef="let element">{{ element.altName }}</td>
            </ng-container>

            <ng-container matColumnDef="color">
              <th mat-header-cell *matHeaderCellDef>Color</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex align-items-center">
                  <div class="color-item me-2" [style]="{background: '#' + element.color}"></div>
                  <div>{{element.color}}</div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="logo">
              <th mat-header-cell *matHeaderCellDef>Logo</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.logo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="background">
              <th mat-header-cell *matHeaderCellDef>Background</th>
              <td mat-cell *matCellDef="let element">
                {{ element.background }}
              </td>
            </ng-container>

            <ng-container matColumnDef="oneTimeEnrollmentFee">
              <th mat-header-cell *matHeaderCellDef>One Time Enrollment Fee</th>
              <td mat-cell *matCellDef="let element">
                {{ element.oneTimeEnrollmentFee ? '$' + element.oneTimeEnrollmentFee : '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let element">
                <button type="button" class="action-menu-btn" mat-icon-button [matMenuTriggerFor]="action_menu">
                  <mat-icon class="action-menu-icon">more_horizontal</mat-icon>
                </button>

                <mat-menu #action_menu="matMenu" xPosition="before">
                  <button mat-menu-item (click)="editDistribution(element)">
                    <span>Edit</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
